import { Fragment, useEffect, useState, useMemo } from "react";

import { PACKAGES } from "router/router";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link, useParams, useNavigate } from "react-router-dom";
import { OtherPackages } from "components/packages";
import { Button } from "components/buttons";
import { useQuery } from "@apollo/client";
import { LOAD_PACKAGE, GET_PROMOTION_POST } from "GraphQL/Queries";

import moment from "moment";
import { images } from "constants";

export const DetailsLayout = ({ children }) => {
  const [packageType, setPackageType] = useState(null);
  const navigate = useNavigate();
  const { id, referral_code } = useParams();
  const userToken = sessionStorage.getItem("token");

  const { loading, data } = useQuery(LOAD_PACKAGE, {
    variables: {
      packageId: id,
    },
  });

  useEffect(() => {
    if (data) {
      setPackageType(data.getPackage?.account_type);
    }
  }, [data]);

  // Query handling
  const skip = !referral_code;

  const { data: promo } = useQuery(GET_PROMOTION_POST, {
    variables: { couponCode: referral_code },
    skip,
  });

  const promoData = useMemo(() => {
    return promo?.getPromotionPost?.promotionPost;
  }, [promo?.getPromotionPost?.promotionPost]);

  const handleButtonClick = () => {
    navigate(`/auth/signup/referralCode/${referral_code}/promotion`);
  };

  return (
    <Fragment>
      <div className="">
        {referral_code && promoData && (
          <section className=" mb-4 relative w-full bg-[#FFF4D6] px-4 py-3 md:py-8 md:px-6 lg:px-8 flex items-center justify-between">
            <div className="flex flex-col md:gap-y-6 sm:gap-y-4 gap-y-2">
              <p className="font-bold text-[#0E4F6D] md:text-[36px] text-[24px]">
                {promoData?.title}
              </p>
              <p className="text-[#475467] ">
                Get {promoData?.couponId?.discountPercentage}% discount off your
                trip using the coupon code:{" "}
                <span className="text-[#FEBB02]">
                  "{promoData?.couponId?.couponCode}"{" "}
                </span>
                <br /> Discount code remains valid for Bookings/Reservations
                till{" "}
                <span className="text-[#093549] font-bold">
                  {moment(promoData?.couponId?.expiresAt).format(
                    "MMMM DD, YYYY",
                  )}
                </span>
              </p>
              {!userToken && (
                <div className="mt-1 max-w-[10em]">
                  <Button
                    text={"Book trip"}
                    isBlue
                    className={" mdLg:px-5"}
                    onClick={handleButtonClick}
                  />
                </div>
              )}
            </div>

            <div className="absolute bottom-0 right-16 md:block hidden max-w-[320px]">
              <img className="w-fit" src={images.promoPerson} alt="" />
            </div>
          </section>
        )}

        <div className="text-blue-200 px-5 sm:px-8 flex flex-col md:flex-row py-10 gap-4">
          <div className="md:w-[70%] w-full ">{children}</div>

          <div className="md:w-[30%] w-full pt-7 md:pt-20">
            {
              <div className="flex flex-col gap-4 items-center">
                <span className=" text-lg md:text-xl font-medium ">
                  Recommended package for you
                </span>
                <div className="md:w-[100%] sm:w-[90%] w-full">
                  <OtherPackages type={packageType} />
                </div>

                <Link to={PACKAGES}>
                  <Button
                    isBlue
                    withIcon
                    icon={<HiArrowNarrowRight size={18} fill="#fff" />}
                    text="View All Packages"
                    className={
                      "flex items-center w-full flex-row-reverse gap-1 mx-auto justify-center px-8"
                    }
                  />
                </Link>
              </div>
            }
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export const SettingsLayout = ({ children }) => {
  return (
    <Fragment>
      <div className="text-blue-200 px-8 flex flex-col md:flex-row py-10 gap-4">
        <div className="md:w-[70%] w-full ">{children}</div>

        <div className="md:w-[30%] w-full pt-7 md:pt-20">
          <div className="flex flex-col gap-4 items-center">
            <span className=" capitalize text-lg md:text-xl font-medium ">
              Other Destination
            </span>
            <div className="md:w-[100%] sm:w-[90%] w-full">
              <OtherPackages />
            </div>

            <Link to={PACKAGES}>
              <Button
                isBlue
                withIcon
                icon={<HiArrowNarrowRight size={18} fill="#fff" />}
                text="View All Packages"
                className={
                  "flex items-center w-full flex-row-reverse gap-1 mx-auto justify-center px-8"
                }
              />
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
